module.exports = __webpack_public_path__ + "img/1-1.a92d68e5.jpg";